module.exports = __webpack_public_path__ + "img/team-nils.a43bcfe8.jpg";